<template>
  <div>
    <search v-if="searchDisable !== true" v-model="search" />
    <div class="filters ai-end">
      <div v-for="dFilter in dateFilter" :key="dFilter.key">
        <label
          >{{ dFilter.title }}
          <span
            v-show="params[dFilter.key]"
            @click="params[dFilter.key] = null"
            class="link"
            >{{ "reset" | setText("сбросить") }}</span
          ></label
        >
        <datetime
          v-model="params[dFilter.key]"
          @input="params['page'] = 1"
          class="from-control"
          type="date"
          format="dd/MM/yyyy"
        ></datetime>
      </div>
      <div v-for="f in staticFilters" :key="f.key">
        <label>{{ f.key | setText(f.title) }}</label>
        <select
          @change="params['page'] = 1"
          v-model="params[f.key]"
          class="form-control"
        >
          <option :value="v.id" v-for="(v, vK) in f.items" :key="vK">
            <template v-if="v.key"> {{ v.key | setText(v.title) }}</template>
            <template v-else>{{ v.title }}</template>
          </option>
        </select>
      </div>
      <div v-for="filter in filters" :key="filter.key">
        <filter-item
          :modal="filter.modal ? filter.modal : filter.key"
          :title="filter.title"
          :single="filter.single"
          :params="filter['params']"
          :titleKey="filter.titleKey"
          :queryKey="filter.queryKey"
          :pushLink="filter.pushLink"
          v-model="
            params[`${filter.queryKey ? filter.queryKey : 
                      filter.field_key ? filter.field_key : filter.key}_id`]
          "
          @input="inputFilter"
        />

      </div>
    </div>
    <div
      :class="` position-relative overflow-hidden ${loading ? 'loading' : ''}`"
    >
      <div
        v-if="
          (value.length && !simple) ||
          isPush ||
          isAdd ||
          isMoveto ||
          setImport === true ||
          is_filter ||
          isUpdate ||
          setImport === true ||
          (functions && functions.length && value.length)
        "
        class="row"
      >
        <div class="col-12">
          <ul class="status">
            <li v-if="isAdd">
              <button class="btn btn-icon" @click="addItem">
                <span class="ti-plus"></span>
                {{ "add" | setText("Добавить") }}
              </button>
            </li>
            <li v-if="isMoveto">
              <button class="btn" @click="movetoItem">
                Перевести в новый класс
              </button>
            </li>
            <li v-if="setImport === true">
              <button class="btn btn-info btn-icon" @click="exportExcel">
                <span class="ti-upload"></span>
                to EXCEL
              </button>
            </li>
            <li v-if="isPush">
              <button
                class="btn btn-info btn-icon"
                @click="$emit('push', true)"
              >
                <span class="ti-plus"></span>
                {{ "push" | setText("Добавить существующего") }}
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>
            <li v-if="isUpdate">
              <button class="btn btn-warning" @click="getList" id="btn-refresh">
                <span class="ti-reload"></span>
                {{ "update" | setText("Обновить") }}
              </button>
            </li>

            <li v-if="functions && functions.length && value.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-sm btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="value.length && !simple">
              <button class="btn btn-sm btn-warning btn-icon" @click="val = []">
                <span class="ti-close"></span>
                Сброить {{ value.length }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <ul v-if="!simple" class="selected-items">
        <li v-for="v in value" :key="v.id">
          <span>{{ v[checkSelect] }}</span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div class="text-right">
        <div v-if="items.last_page" class="modal-title badge badge-danger">
          {{ "total" | setText("всего") }} {{ items.total }}
        </div>
      </div>
      <div class="row" v-if="columns && columns.length && items">
        <template v-if="Object.keys(dataClasses).length && cardLink == 'item_lessonplan_list'">
          <div class="col-12">
            <tabs :tabs="dataClasses" :active="classesTab" v-model="classesTab" style="z-index: 19;"/>
            <template v-for="(tab, key) in dataClasses">
              <div v-if="classesTab === key" :key="key">
                <paper-table
                  :holidays="holidays"
                  :additionalId="additionalId"
                  :drag="search ? false : drag"
                  v-show="items.data.length"
                  type="hover"
                  :simple="simple"
                  :items="items"
                  :itemLink="itemLink"
                  :card="cardLink"
                  :cardLink="cardLink"
                  :data="tab.data"
                  @changeData="changeData"
                  :columns="columns"
                  :removeItem="removeItem"
                  v-model="val"
                  :dataObject="dataObject"
                  :current_page="items.current_page"
                  @sortby="sortby"
                ></paper-table>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="col-12">
            <slot name="tableTabs"></slot>
            <div class="table-full-width table-responsive">
              <paper-table
                :holidays="holidays"
                :additionalId="additionalId"
                :drag="search ? false : drag"
                v-show="items.data.length"
                type="hover"
                :simple="simple"
                :items="items"
                :itemLink="itemLink"
                :card="cardLink"
                :cardLink="cardLink"
                :data="items.data"
                @changeData="changeData"
                :columns="columns"
                :removeItem="removeItem"
                :removeModal="removeModal"
                v-model="val"
                :dataObject="dataObject"
                :current_page="items.current_page"
                @sortby="sortby"
              ></paper-table>
              <h4 v-if="items.data.length === 0">
                {{ "not_found" | setText("Не найдено (пусто)") }}
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-if="items.per_page && items.last_page > 1">
        <!--NEW PERPAGE SET-->

        <h5>{{ "on_page" | setText("На странице") }}:</h5>

        <select v-model="items.per_page" @input="setPerPage">
          <option v-for="pP in perPages" :value="pP" :key="pP">
            {{ pP }}
          </option>
        </select>

        <!--NEW-->
      </div>
      <div class="fixed-pagination">
        <div class="responsive-pagination">
          <div v-if="items.last_page > 1">
            <input
              class="responsive-pagination-input"
              type="number"
              @input="setPage"
            />
          </div>
          <paginate
            v-if="items.last_page"
            v-show="items.last_page > 1"
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'‹'"
            :nextText="'›'"
          >
          </paginate>
        </div>
      </div>
    </div>

    <export-excel
      :exportFields="exportFields"
      :itemLink="itemLink"
      :params="params"
    />
    <add-item
      :openItem="openItem"
      @close="add = false"
      v-if="isAdd && fields && fields.length && setLink && add === true"
      :fieldsFrom="fields"
      :fieldClass="fieldClass"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
    <moveto
      :openItem="openItem"
      @close="moveto = false"
      v-if="isMoveto && fields && fields.length && setLink && moveto === true"
      :fieldsFrom="fields"
      :fieldClass="fieldClass"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import Search from "./Search";
import { errorNotify } from "@/plugins/functions";
import { mapState } from "vuex";
export default {
  name: "List",
  data() {
    return {
      add: false,
      moveto: false,
      season: null,
      classesTab: 0,
      dataClasses: [],
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },
      dataObject: {},
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        per_page: 15,
        data: [],
      },
      holidays: {},
      perPages: [15, 20, 50, 100, 500],
    };
  },
  components: {
    PaperTable,
    // AddItem,
    Search,
    "add-item": () => import("./Modals/AddItem"),
    "moveto": () => import("./Modals/Moveto"),
    "export-excel": () => import("@/components/ExportExcel"),
  },

  props: {
    openItem: {
      default: true,
    },
    isPush: {
      default: false,
    },
    value: {
      default: function () {
        return [];
      },
    },
    searchDisable: {},
    setLink: {},
    itemLink: {},
    title: {},
    exportFields: {},
    simple: {
      default: false,
    },
    drag: {
      default: false,
    },
    setImport: {
      default: false,
    },
    columns: {},
    removeLink: {},
    cardLink: {},
    modalCreate: {},
    disable_add: {},
    is_filter: {},
    isAdd: {},
    isMoveto: {},
    isUpdate: {},
    functions: {},
    fields: {},
    fieldClass: '',
    additionalId: {
      default: null,
    },
    removeModal: {
      default: function () {},
    },
    params: {
      default: function () {
        return {};
      },
    },
    filters: {
      default: function () {
        return [];
      },
    },
    dateFilter: {
      default: function () {
        return [];
      },
    },
    staticFilters: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    checkSelect() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].checkbox === true) {
          return this.columns[i].key;
        }
      }
      return null;
    },
    ...mapState(["newOrder", "lastUpdate"]),
    page() {
      return this.items.current_page;
    },
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val) {
      if (val) {
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    inputFilter(){
      this.params['page'] = 1
    },
    setPage(event) {
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        let page = event.target.value;
        this.items.current_page = parseInt(page);
      }, 600);
    },
    exportExcel() {
      this.$modal.show("export");
    },
    changeData(val) {
      this.items.data = val;
    },
    sortby(val) {
      this.sort = val;
      this.getList();
    },
    addItem() {
      this.add = true;
    },
    movetoItem() {
      this.moveto = true;
    },
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    removeItem(itemID) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);


          this.$http
            .post(`${this.itemLink}/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getList(loading = true, resetPage = false) {
      let params = this.params ? this.params : {};

      params["page"] = this.items.current_page;
      params["per_page"] = this.items.per_page;
      params["search"] = this.search;
      
      if (!params["order"])
        params["order"] = `${this.sort.orderType === "DESC" ? "" : "-"}${
          this.sort.orderBy
        }`;

      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage === true) {
        params["page"] = 1;
      }

      if (this.$store.state.business) {
        params.business_id = this.$store.state.business.id;
      }

      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data.data) {
            this.items.data = response.data.data;
            if (response.data.holidays) {
              this.holidays = response.data.holidays;
            }
            if(response.data.meta){
              this.items.total = response.data.meta.total;
              const perPage = response.data.meta.per_page;
              this.items.per_page = perPage;
              this.items.last_page = Math.ceil(this.items.total / perPage);
            }
            let data = response.data.data;
            for (let i = 0; i < this.value.length; i++) {
              this.dataObject[this.value[i].id] = this.value[i];
            }
            for (let i = 0; i < data.length; i++) {
              this.dataObject[data[i].id] = data[i];
            }
            let courses = {}
            this.dataClasses = []
            this.classesTab = 0
            for (let i = 0; i < data.length; i++) {
              if(!data[i].course)
                continue
              if(!courses[data[i].course.position])
                courses[data[i].course.position] = [];    
              courses[data[i].course.position].push(data[i]);
            }
            for (const i in courses) {
              if (Object.hasOwnProperty.call(courses, i)) {
                this.dataClasses.push({
                  title: `Класс ${i}`,
                  data: courses[i]
                })
              }
            }
          }else{
            if(this.itemLink == 'system'){
              let courses = []
              for (const key in response.data.courses) {
                if (Object.hasOwnProperty.call(response.data.courses, key)) {
                  const element = response.data.courses[key]; 
                  courses.push({id: element, position: key, title: key})
                }
              }
              for (let i = 0; i < this.value.length; i++) {
                this.dataObject[this.value[i].id] = this.value[i];
              }
              for (let i = 0; i < courses.length; i++) {
                this.dataObject[courses[i].id] = courses[i];
              }
              this.items.data = courses
            }
          }
          if (response.data.type) {
            this.$emit("type", response.data.type);
          }
          
          this.$emit("succress", true);
        })
        .catch((error) => {
          console.log(error, 'error')
          this.$emit("error", true);
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },

    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
    setPerPage(event) {
      this.items.current_page = 1;
      setTimeout(() => {
        this.getList();
      }, 10);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss">
ul.selected-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  overflow-x: scroll;
  max-width: 100%;

  @media (min-width: 769px) {
    flex-wrap: wrap;
  }

  & > li {
    max-width: 180px;
    border-radius: 5px;
    margin-right: 10px;
    background: #222;
    color: #fff;
    font-size: 10px;
    margin-bottom: 10px;
    padding: 4px 6px;
    display: flex;
    & > span {
      display: block;
      &:last-child {
        font-size: 8px;
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
